import classNames from 'classnames';
import { PropsWithChildren } from 'react';

export interface FadeProps {
  show?: boolean;
}

export function Fade({
  children,
  show,
}: PropsWithChildren<FadeProps>): JSX.Element {
  return (
    <div
      className={classNames(
        'transition-opacity duration-500 font-label',
        !show ? 'opacity-0' : 'opacity-100',
      )}
    >
      {children}
    </div>
  );
}
